import {
  TestimonialSolo as TestimonialSoloZDS,
  TestimonialSoloProps,
} from '@zapier/design-system';
import { RichTextHtml } from '../../RichTextHtml/RichTextHtml';
import { RichTextHTMLString } from '../types';

type Props = Omit<TestimonialSoloProps, 'backgroundColor'> & {
  background: TestimonialSoloProps['backgroundColor'];
  quote: RichTextHTMLString;
};

export function TestimonialSolo({ background, quote, ...restProps }: Props) {
  return (
    <TestimonialSoloZDS
      backgroundColor={background}
      quote={<RichTextHtml backgroundColor={background} html={quote} />}
      {...restProps}
    />
  );
}
